import * as React from "react";

const ArrowIcon = (props) => (
	<svg
		width="6"
		height="11"
		viewBox="0 0 6 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props} // позволит прокидывать className, style и т.д.
	>
		<path
			d="M1 9.5L5 5.5L1 1.5"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default ArrowIcon;